export default "__VITE_ASSET__nU3XwjFj__"